import React from "react";
import RankedItemsReport from "../../components/Report/RankedItemsReport";

const BestSellingReportPage: React.FC = () => <RankedItemsReport variant="best-selling" />;
export default BestSellingReportPage;
